// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { enableDebugTools, enableDebugToolbar } from './debugActions';

// Utils
import { shouldEnableDebugFeatures, shouldShowDebugToolbar } from './debugUtil';

const mapDispatchToProps = (dispatch, ownProps) => ({
    enableDebugFeatures: () => dispatch(enableDebugTools()),
    enableDebugToolbar: () => dispatch(enableDebugToolbar()),
});

export default (DecoratedComponent) => {
    @connect(null, mapDispatchToProps)
    class DebugManagerDecorator extends React.Component {
        constructor(props) {
            super(props);
            window.enableDebug = this.enableDebugFeatures;
            window.enableDebugToolbar = this.enableDebugToolbar;
        }

        componentWillMount() {
            if (shouldEnableDebugFeatures()) {
                console.info('Milanote debug tools enabled');
                this.enableDebugFeatures();
            }

            if (shouldShowDebugToolbar()) this.enableDebugToolbar();
        }

        enableDebugFeatures = () => {
            this.props.enableDebugFeatures();
        };

        enableDebugToolbar = () => {
            this.props.enableDebugToolbar();
        };

        render() {
            return <DecoratedComponent {...this.props} />;
        }
    }

    DebugManagerDecorator.propTypes = {
        enableDebugFeatures: PropTypes.func,
        enableDebugToolbar: PropTypes.func,
    };

    return DebugManagerDecorator;
};
